import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Claim } from '@core/model';
import { ClaimService } from '@core/service';
import { DatePicker } from 'primeng/datepicker';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-claim-search',
    templateUrl: './claim-search.component.html',
    styleUrls: ['./claim-search.component.scss'],
    standalone: false
})
export class ClaimSearchComponent implements OnInit {
  @Input() tenantId: string;
  @Input() tenantName: string;
  isExternal: true;
  claimSearch: Claim;
  claims: Claim[];

  searchClaimForm: FormGroup;

  @ViewChild('fromDate', { static: true }) fromDatePicker: DatePicker;
  @ViewChild('toDate', { static: true }) toDatePicker: DatePicker;
  constructor(
    private claimsService: ClaimService,
    private router: Router
  ) {
    this.claimSearch = { tenant: '', tenantId: '', transID: '', startDate: '', stopDate: '' };
  }

  ngOnInit() {
    this.searchClaimForm = new FormGroup({
      claimId: new FormControl(''),
      paymentDateToPicker: new FormControl('', [Validators.required]),
      paymentDateFromPicker: new FormControl('', [Validators.required]),
    });

    this.formChanges();
  }

  reset(): void {
    this.searchClaimForm.reset();
  }
  formChanges(): void {
    const claimId = this.searchClaimForm.get('claimId');
    const fromDate = this.searchClaimForm.get('paymentDateFromPicker');
    const toDate = this.searchClaimForm.get('paymentDateToPicker');

    this.searchClaimForm.get('claimId').valueChanges.pipe(distinctUntilChanged()).subscribe(data => {
      if (!!data) {
        fromDate.setValidators(null);
        toDate.setValidators(null);
        fromDate.updateValueAndValidity();
        toDate.updateValueAndValidity();
        fromDate.disable();
        toDate.disable();
      } else {
        fromDate.setValidators([Validators.required]);
        toDate.setValidators([Validators.required]);
        fromDate.updateValueAndValidity();
        toDate.updateValueAndValidity();
        fromDate.enable();
        toDate.enable();
      }
    });

    this.searchClaimForm.get('paymentDateFromPicker').valueChanges.pipe(distinctUntilChanged()).subscribe(data => {
      if (!!data) {
        claimId.disable();
      } else {
        claimId.enable();
      }
    });
    this.searchClaimForm.get('paymentDateToPicker').valueChanges.pipe(distinctUntilChanged()).subscribe(data => {
      if (!!data) {
        claimId.disable();
      } else {
        claimId.enable();
      }
    });
  }

  searchClaims(): void {
    sessionStorage.setItem('tenantName', this.tenantName);
    sessionStorage.setItem('tenantId', this.tenantId);
    this.claimSearch.tenant = this.tenantName;
    this.claimSearch.tenantId = this.tenantId;
    this.claimSearch.transID = '';
    this.claimSearch.startDate = '';
    this.claimSearch.stopDate = '';

    if (!!this.searchClaimForm.value['claimId']) {
      this.claimSearch.transID = !!this.searchClaimForm.value['claimId']
        ? String(this.searchClaimForm.controls['claimId'].value).trim() : '';
    } else {
      this.claimSearch.startDate = !!this.searchClaimForm.value['paymentDateFromPicker']
        ? this.searchClaimForm.controls['paymentDateFromPicker'].value.toLocaleString() : '';
      this.claimSearch.stopDate = !!this.searchClaimForm.value['paymentDateToPicker']
        ? this.searchClaimForm.controls['paymentDateToPicker'].value.toLocaleString() : '';
    }
    this.claimsService.searchResults = null;
    this.claimsService.getClaims(this.claimSearch).subscribe(
      res => {
        if (!!res) {
          this.claimsService.searchResults = res;
          this.router.navigate(['/', 'claims']).then(() => this.reset());
        } else {
          this.router.navigate(['/', 'claims']).then(() => this.reset());
        }
      },
      () => {
        // TODO: Display Error
      }
    );
  }
}
